import { Icon } from '@getpay93/ui';
import { PublicNav } from './PublicNav';
import { PublicFooter } from './PublicFooter';

const verticals: Array<{ name: string; icon: string }> = [
  { name: 'Gimnasios', icon: 'dumbbell' },
  { name: 'Coaches', icon: 'user' },
  { name: 'Estudios', icon: 'music' },
  { name: 'Profesores', icon: 'graduation-cap' },
  { name: 'Nutricionistas', icon: 'salad' },
];

const features: Array<{ icon: string; title: string; body: string }> = [
  { icon: 'repeat', title: 'Cobranza automática', body: 'Facturas recurrentes y recordatorios que salen solos, antes y después del vencimiento.' },
  { icon: 'file-check', title: 'Comprobantes de pago', body: 'Tu cliente sube la foto del pago; tú apruebas o rechazas en un toque.' },
  { icon: 'bar-chart-3', title: 'Reportes de cobranza', body: 'Tasa de cobro mensual, top deudores y export CSV/PDF.' },
];

export function Landing() {
  return (
    <div className="gp-light" style={{ minHeight: '100vh', background: 'var(--bg)', fontFamily: 'var(--font-sans)' }}>
      <PublicNav />

      <section style={{ maxWidth: 1160, margin: '0 auto', padding: '56px 48px 40px', display: 'grid', gridTemplateColumns: '1.05fr 0.95fr', gap: 48, alignItems: 'center', boxSizing: 'border-box' }}>
        <div>
          <span style={{ display: 'inline-flex', padding: '5px 12px', borderRadius: 999, background: 'var(--status-paid-bg)', color: 'var(--status-paid)', fontSize: 12, fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 20 }}>Para gimnasios, coaches y estudios</span>
          <h1 style={{ fontSize: 52, lineHeight: 1.05, fontWeight: 800, letterSpacing: '-0.02em', color: 'var(--text-strong)', margin: '0 0 20px' }}>Cobra tus membresías sin perseguir a nadie.</h1>
          <p style={{ fontSize: 19, lineHeight: 1.5, fontWeight: 500, color: 'var(--text-muted)', margin: '0 0 28px', maxWidth: 460 }}>Recordatorios automáticos por email y WhatsApp, links de pago y comprobantes en un solo lugar.</p>
          <div style={{ display: 'flex', gap: 14 }}>
            <a href="/registro" style={{ display: 'inline-flex', alignItems: 'center', height: 56, padding: '0 24px', background: 'var(--brand-green)', color: '#FFFFFF', borderRadius: 12, fontSize: 18, fontWeight: 800, textDecoration: 'none' }}>Empieza gratis — hasta 10 clientes</a>
            <a href="/precios" style={{ display: 'inline-flex', alignItems: 'center', height: 56, padding: '0 24px', border: '1.5px solid var(--border-strong)', color: 'var(--text-body)', borderRadius: 12, fontSize: 18, fontWeight: 800, textDecoration: 'none' }}>Ver precios</a>
          </div>
          <p style={{ marginTop: 16, marginBottom: 0, fontSize: 15, fontWeight: 600, color: 'var(--text-muted)' }}>
            ¿Ya eres cliente de un negocio que usa GetPay93? <a href="/registro?tipo=cliente" style={{ color: 'var(--brand-green)' }}>Crea tu cuenta</a>
          </p>
          <div style={{ display: 'flex', gap: 24, marginTop: 32, flexWrap: 'wrap' }}>
            {verticals.map((v) => (
              <div key={v.name} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, fontWeight: 700, color: 'var(--text-muted)' }}>
                <Icon name={v.icon} size={18} />{v.name}
              </div>
            ))}
          </div>
        </div>

        <div style={{ background: 'var(--brand-green)', borderRadius: 24, padding: 28, boxShadow: 'var(--shadow-light-raised)' }}>
          <div style={{ background: '#0F172A', borderRadius: 16, padding: 18 }}>
            <div style={{ display: 'flex', gap: 12, marginBottom: 14 }}>
              <div style={{ flex: 1, background: '#1E293B', border: '1px solid #334155', borderRadius: 14, padding: 16 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#94A3B8', marginBottom: 8 }}>Total Mes</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#21C45D', lineHeight: 1 }}>$12,450</div>
              </div>
              <div style={{ flex: 1, background: '#1E293B', border: '1px solid #334155', borderRadius: 14, padding: 16 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#94A3B8', marginBottom: 8 }}>Pendiente</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#F59E0B', lineHeight: 1 }}>$2,105</div>
              </div>
            </div>
            <div style={{ background: '#1E293B', border: '1px solid #334155', borderRadius: 14, padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <div style={{ fontSize: 16, fontWeight: 700, color: '#FFFFFF' }}>Juan Pérez</div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#94A3B8', marginTop: 2 }}>Plan: Anual VIP</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 19, fontWeight: 800, color: '#21C45D' }}>$150.00</div>
                  <span style={{ display: 'inline-flex', padding: '3px 8px', borderRadius: 999, background: 'rgba(33,196,93,0.15)', color: '#21C45D', fontSize: 10, fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', marginTop: 4 }}>Cobrado</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="features" style={{ maxWidth: 1160, margin: '0 auto', padding: '32px 48px 64px', boxSizing: 'border-box' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 20 }}>
          {features.map((f) => (
            <div key={f.title} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16, padding: 24, boxShadow: 'var(--shadow-light-card)' }}>
              <div style={{ width: 44, height: 44, borderRadius: 12, background: 'var(--brand-green-soft)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14, color: 'var(--brand-green)' }}>
                <Icon name={f.icon} size={22} />
              </div>
              <div style={{ fontSize: 17, fontWeight: 800, color: 'var(--text-strong)', marginBottom: 6 }}>{f.title}</div>
              <div style={{ fontSize: 14, lineHeight: 1.5, fontWeight: 500, color: 'var(--text-muted)' }}>{f.body}</div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: 'center', marginTop: 48, fontSize: 15, fontWeight: 700, color: 'var(--text-muted)' }}>Sin comisiones. Sin permanencia. Cancela cuando quieras.</div>
      </section>

      <section style={{ background: 'var(--brand-green)' }}>
        <div style={{ maxWidth: 1160, margin: '0 auto', padding: 48, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 24, boxSizing: 'border-box' }}>
          <div>
            <h2 style={{ fontSize: 32, fontWeight: 800, color: '#062915', margin: '0 0 6px', letterSpacing: '-0.01em' }}>Empieza a cobrar hoy.</h2>
            <p style={{ fontSize: 17, fontWeight: 600, color: 'rgba(6,41,21,0.75)', margin: 0 }}>Sin tarjeta. Sin comisiones sorpresa.</p>
          </div>
          <a href="/registro" style={{ display: 'inline-flex', alignItems: 'center', height: 56, padding: '0 24px', background: '#FFFFFF', color: '#062915', borderRadius: 12, fontSize: 18, fontWeight: 800, textDecoration: 'none' }}>Crear cuenta gratis</a>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}
